import { AnyAction } from 'redux';
import { ITopArtist } from '#/types/API/topArtists';
import { ITopTrack } from '#/types/API/topTracks';
import { ILoadingError } from '#/types/global';
import {
  createActionUserProfileAddTopArtists,
  createActionUserProfileAddTopTracks,
  createActionUserProfileErrorTopArtists,
  createActionUserProfileErrorTopTracks,
  createActionUserProfileLoadingTopArtists,
  createActionUserProfileLoadingTopTracks,
  createActionUserProfileSetTopTrackIsFavorite,
} from '../actions/userProfile';

export interface ITopTrackWithFavorite extends ITopTrack {
  favorite: boolean;
}

interface IState {
  topArtists: ITopArtist[] | ILoadingError;
  topTracks: ITopTrackWithFavorite[] | ILoadingError;
}

const initialState: IState = {
  topArtists: { _loading: true, _error: false },
  topTracks: { _loading: true, _error: false },
};

const userProfile = (
  state: IState = initialState,
  action: AnyAction
): IState => {
  if (createActionUserProfileAddTopArtists.doesMatch(action)) {
    return { ...state, topArtists: [...action.payload] };
  }

  if (createActionUserProfileLoadingTopArtists.doesMatch(action)) {
    return { ...state, topArtists: { ...state.topArtists, _loading: true } };
  }

  if (createActionUserProfileErrorTopArtists.doesMatch(action)) {
    return { ...state, topArtists: { ...state.topArtists, _error: true } };
  }

  if (createActionUserProfileAddTopTracks.doesMatch(action)) {
    return { ...state, topTracks: [...action.payload] };
  }

  if (createActionUserProfileSetTopTrackIsFavorite.doesMatch(action)) {
    if (Array.isArray(state.topTracks)) {
      const newTopTracks = state.topTracks.map((topTrack) => {
        if (topTrack.id === action.payload.track) {
          topTrack.favorite = action.payload.favorite;
        }
        return topTrack;
      });
      return { ...state, topTracks: newTopTracks };
    }
    return state;
  }

  if (createActionUserProfileLoadingTopTracks.doesMatch(action)) {
    return { ...state, topTracks: { ...state.topTracks, _loading: true } };
  }

  if (createActionUserProfileErrorTopTracks.doesMatch(action)) {
    return { ...state, topTracks: { ...state.topTracks, _error: true } };
  }

  return state;
};

export default userProfile;
